"use client";

import { useBookingEngineContext } from "../../cin_context/BookingEngineContext";
import React, { useEffect, useState, useMemo, useRef } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import axios from "axios";
import { createSignature } from "../../../app/utilities/signature";

const styles = {
  input: {
    padding: "5px",
    fontSize: "12px",
    width: "250px",
  },
};

const DatePicker = ({ selectedStartDate, selectedEndDate , onClose }) => {
  const { setSelectedDates, selectedPropertyId } = useBookingEngineContext();
  const [pricesMap, setPricesMap] = useState({});
  const dateInputRef = useRef(null);
    const pricesMapRef = useRef({});
  const pricesMapRef2 = useRef({});
 const defaultDesabledDate = useRef(null);
  const loadingRef = useRef(true);
  const flatpickrInstanceRef = useRef(null);
    const flatpickrRef = useRef(null);
  const fetchedRef = useRef(false);
  
const IST_OFFSET_MINUTES = 330;

const getShiftedDateForFlatpickr = (date = new Date()) => {
  const localOffset = date.getTimezoneOffset(); // in minutes
  const diffMinutes = IST_OFFSET_MINUTES + localOffset;
  return new Date(date.getTime() + diffMinutes * 60 * 1000);
};

const parseISTStringToDateForFlatpickr = (istDateStr) => {
  const [y, m, d] = istDateStr.split("-").map(Number);

  // Create date at NOON to avoid timezone shifts
  const date = new Date(y, m - 1, d);
  date.setHours(12, 0, 0, 0);

  return date;
};

const formatISTDate = (date) =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);

const currentDate = useMemo(() => {
  const d = getShiftedDateForFlatpickr(new Date());
  d.setHours(0, 0, 0, 0);
  return d;
}, []);


const sixMonthsLater = useMemo(() => {
  const d = new Date(currentDate);
  d.setMonth(d.getMonth() + 6);
  return d;
}, [currentDate]);


const fromDateEt = useMemo(
  () => formatISTDate(currentDate),
  [currentDate]
);

const toDateEt = useMemo(
  () => formatISTDate(sixMonthsLater),
  [sixMonthsLater]
);
  
const fromDate = useMemo(() => {
  const d = getShiftedDateForFlatpickr(new Date());
  d.setHours(0, 0, 0, 0);
  return d;
}, []);

  const formatDate = (date) => formatISTDate(date);
  
const formatDate2 = (input) => {
  if (!input) return "";

  let date;

  // Case 1: Already a Date object
  if (input instanceof Date) {
    if (isNaN(input.getTime())) return "";
    date = input;
  }
  // Case 2: yyyy-mm-dd string (API data)
  else if (typeof input === "string") {
    const [y, m, d] = input.split("-").map(Number);
    if (!y || !m || !d) return "";

    // Create UTC date, then interpret in IST via Intl
    date = new Date(Date.UTC(y, m - 1, d));
  }
  else {
    return "";
  }

  // Format in IST
  const parts = new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).formatToParts(date);

  const day = parts.find(p => p.type === "day")?.value;
  const month = parts.find(p => p.type === "month")?.value;
  const year = parts.find(p => p.type === "year")?.value;

  if (!day || !month || !year) return "";

  return `${day}-${month}-${year}`;
};
  // Fetch price
  useEffect(() => {
    if (fetchedRef.current) return;
    loadingRef.current = true;
    fetchedRef.current = true;
    const fetchPrices = async () => {
      try {
        const timestamp = Date.now().toString();
        const secret = "ABDEFGHJKLMOPQRSTUVWXYZ123456789";
        const signature = await createSignature(
          JSON.stringify(selectedPropertyId),
          timestamp,
          secret
        );
        
         const body = {
      selectedPropertyId: selectedPropertyId,
      fromDate: fromDateEt,
      toDate: toDateEt
      // product: "No",
    };
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_STAAH_BASE_URL}/api/cin-api/rate-et`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-timestamp": timestamp,
              "x-signature": signature,
            },
            body: JSON.stringify(body),
          }
        );

        const data = await response.json();
        const dayRate = data?.PropertyList?.[0]?.DayRate || {};
        const prices = {};
         const prices2 = {};
        for (const date in dayRate) {
          prices[date] = dayRate[date]?.Rate || 0;
           prices2[formatDate2(date)] = dayRate[date]?.Rate || 0;
        }
        setPricesMap(prices);
         pricesMapRef.current = prices;
         pricesMapRef2.current = prices2;
         const disabledDates = Object.entries(prices2)
    .filter(([date, price]) => price == "0" || price == 0 || price == "N/A") 
    .map(([date]) => date);
    defaultDesabledDate.current = disabledDates;
      } catch (error) {
        console.error("Error fetching prices:", error);
      } finally {
        loadingRef.current = false;
        if (flatpickrRef?.current) {
           flatpickrRef?.current?.redraw();
         }
      }
    };

    fetchPrices();
  }, [selectedPropertyId, fromDateEt, toDateEt]);

  // Inject prices into calendar
  useEffect(() => {
    if (!dateInputRef.current) return;

    flatpickrInstanceRef.current = flatpickr(dateInputRef.current, {
      mode: "range",
      dateFormat: "d-m-Y",
      minDate: fromDate,
      showMonths: 1,
      static: true,
      fixedHeight: true,
      showOutsideDays: false,
      disable: [],
      defaultDate:
        selectedStartDate && selectedEndDate
          ? [new Date(selectedStartDate), new Date(selectedEndDate)]
          : null,
      onChange: (selectedDates, dateStr, fp) => {
        if (selectedDates.length === 1) {
      // ✅ When only check-in is selected → restrict checkout date
      const startDate = selectedDates[0];
      const formatted = formatDate2(startDate);
      const price = pricesMapRef2.current?.[formatted];
      // Prevent N/A or 0 date as check-in
      if (!price || price === "N/A" || price === "0" || price === 0) {
    // Find the next available date with price > 0
    let found = false;
    for (let i = 1; i <= 30; i++) { // check next 30 days max
      startDate.setDate(startDate.getDate() + 1);
      const nextFormatted = formatDate2(startDate);
      const nextPrice = pricesMapRef2.current?.[nextFormatted];
      if (nextPrice && nextPrice !== "N/A" && nextPrice !== "0" && nextPrice !== 0) {
        found = true;
        break;
      }
    }

    if (found) {
      // Set minDate to next valid date (so user can select checkout from here)
      fp.set("minDate", startDate);
    }else {
      // No valid date found ahead — reset picker
      fp.clear();
    }
    return;
  }
      // Allow it to restrict checkout from same or later date
      fp.set("minDate", startDate);
    }
        if (selectedDates?.length === 2) {
      let [startDate, endDate] = selectedDates;

      // ✅ Same date → shift checkout +1 day
      if (startDate.toDateString() === endDate.toDateString()) {
        endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 1);
        fp.setDate([startDate, endDate], true);
      }

    const startDateFormatted = formatISTDate(startDate);
    const endDateFormatted = formatISTDate(endDate);

      // setIsDateChanged(true);

      let priceSum = 0;
      const tempDate = new Date(startDate);
      while (tempDate <= endDate) {
        const dateKey = formatDate(tempDate);
        if (pricesMapRef?.current?.[dateKey]) {
          priceSum += pricesMapRef?.current?.[dateKey];
        }
        tempDate.setDate(tempDate.getDate() + 1);
      }

      setSelectedDates(startDateFormatted, endDateFormatted, priceSum);
    }
      },
  onClose: (selectedDates, dateStr, fp) => {
    if (selectedDates.length === 1) {
      // ✅ User closed after only check-in date → auto-assign next day
      const startDate = selectedDates[0];
      const checkOutDate = new Date(startDate);
      checkOutDate.setDate(checkOutDate.getDate() + 1);

      fp.setDate([startDate, checkOutDate], true);

    const startDateFormatted = formatISTDate(startDate);
    const endDateFormatted = formatISTDate(checkOutDate);

      setIsDateChanged(true);

      let priceSum = 0;
      const tempDate = new Date(startDate);
      while (tempDate <= checkOutDate) {
        const dateKey = formatDate(tempDate);
        if (pricesMap[dateKey]) {
              priceSum += pricesMap[dateKey];
            }
        tempDate.setDate(tempDate.getDate() + 1);
      }

      setSelectedDates(startDateFormatted, endDateFormatted, priceSum);
    }
  },
      onDayCreate: (dObj, dStr, fp, dayElem) => {
        if (!dayElem?.dateObj) return;

        const date = formatDate(dayElem?.dateObj);
        const priceTag = document.createElement("div");
        priceTag.className = "flatpickr-price";
        priceTag.style.fontSize = "10px";
        priceTag.style.position = "absolute";
        priceTag.style.bottom = "8px";
        priceTag.style.left = "50%";
        priceTag.style.transform = "translateX(-50%)";

        if (loadingRef?.current) {
          priceTag.innerHTML = `<div class="skeleton-loader"></div>`;
        } 
        
       else if (pricesMap?.[date] == 0 || pricesMap?.[date] == "0" || pricesMap?.[date] === "N/A") {
         priceTag.innerHTML = `<span class="na-text">N/A</span>`;
         dayElem.style.opacity = "0.5"; // visually disabled but clickable
       }
      else if (pricesMap[date] !== undefined) {
        if (pricesMap?.[date] == 0 || pricesMap[date] == "0" || pricesMap[date] === "N/A") {
          priceTag.innerHTML = `<span class="na-text">N/A</span>`;
          dayElem.classList.add("flatpickr-disabled");
          dayElem.style.pointerEvents = "none";
         // dayElem.style.opacity = "0.4";
        } else {
          priceTag.textContent = pricesMap[date];
        }
      }
        dayElem.appendChild(priceTag);
      },
      onClose: () => {
        if (onClose) onClose();  // ✅ notify parent when closed
      }
    });

    flatpickrInstanceRef.current.open();

    flatpickrRef.current = flatpickrInstanceRef.current;
    return () => {
      flatpickrInstanceRef.current.destroy();
    };
  }, [pricesMap]);


  return (
    <div style={styles.input} className="flatpicker-for-calender-date">
      
      <style>
  {`
    .skeleton-loader {
      width: 40px;
      height: 10px;
      background: linear-gradient(90deg, #eee 25%, #ddd 50%, #eee 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s linear infinite;
      border-radius: 4px;
    }
    @keyframes shimmer {
      0% { background-position: -200% 0; }
      100% { background-position: 200% 0; }
    }
    .na-text {
      color: red !important;
      font-weight: 600;
    }
  `}
</style>
      <input
        id="datePicker"
        ref={dateInputRef}
        placeholder="Please Select Date"
        className="form-control"
        style={{
          display: "none", // set to block if needed
        }}
      />
    </div>
  );
};

export default DatePicker;
